import {UserSource} from "@/store/player/types";
import {Tr} from "@/i18n/i18n";
import SoundUtils from "@/utils/sound-utils";
import {IapService} from "@/services/iap-service";
import {IntegrationUtils} from "@/utils/integration-utils";
import ShopStore from "@/store/shop";
import {IAPProduct} from "@awesome-cordova-plugins/in-app-purchase-2/ngx";
import {ShopService} from "@/services/shop-service";
import {PaymentNotificationService} from "@/services/payment-notification-service";
import {BankOption} from "@/store/shop/types";
import {PaymentChangeService} from "@/services/payment-change-service";
import BaseSound = Phaser.Sound.BaseSound;
import {BeelinePayConfirmationPanel} from "@/scenes.ui/beeline-pay-confirmation-panel";
import {Keys} from "@/constants/key";

export default class ShopUtils {

    public static buy(googleProduct: IAPProduct | undefined, awardSound: BaseSound | undefined, userSource: UserSource,
                       paymentNotificationService: PaymentNotificationService, iapService: IapService,
                       paymentChangeService: PaymentChangeService,
                       bo: BankOption, externalUser: boolean, ) {
        SoundUtils.play(awardSound);
        // @ts-ignore
        if (typeof Window.ensureNoFullscreen === 'function') {
            // @ts-ignore
            Window.ensureNoFullscreen();
        }
        if (IapService.IapEnabled()) {
            paymentNotificationService.setupPaymentCheckingTask();

            if (googleProduct !== undefined) {
                console.log(`PurchaseStore: Trying to Google Purchase. JSON Product: ${JSON.stringify(googleProduct)}`)
                ShopService.logClient(`PurchaseStore: Trying to Google Purchase. JSON Product: ${JSON.stringify(googleProduct)}`)
                try {
                    iapService.purchase(googleProduct)
                    console.log("PurchaseStore: Success")
                    ShopService.logClient("PurchaseStore: Success")
                } catch (e) {
                    console.log(`PurchaseStore: ERROR Google Purchase ${e.message}`)
                    ShopService.logClient(`PurchaseStore: ERROR Google Purchase ${e.message}`)
                }
            } else {
                console.log(`PurchaseStore: Can not to Google Purchase. Google Product is undefined`)
                ShopService.logClient(`PurchaseStore: Can not to Google Purchase. Google Product is undefined`)
            }
            return
        }

        if (userSource === UserSource.ok) {

            paymentNotificationService.setupPaymentCheckingTask();
            let gemsCount = bo.gems + bo.bonus;
            IntegrationUtils.showOkPaymentDialog(bo.price, String(gemsCount) + Tr('izumrudov'),
                Tr('game.credits'), String(gemsCount) + ' gems');

        } else if (userSource === UserSource.vk) {
            paymentNotificationService.setupPaymentCheckingTask();
            IntegrationUtils.showVkPaymentDialog(bo.id);
        } else if (userSource === UserSource.ya) {
            paymentNotificationService.setupPaymentCheckingTask();
            IntegrationUtils.showYaPaymentDialog(bo.id,() => {});
        } else if (userSource === UserSource.exe) {
            paymentNotificationService.setupPaymentCheckingTask();
            IntegrationUtils.showExePaymentDialog(bo.id);
        } else if (userSource === UserSource.mystore) {
            paymentNotificationService.setupPaymentCheckingTask();
            IntegrationUtils.showMystorePaymentDialog(bo.id, bo.price, bo.gems + bo.bonus, bo.valuteName);
        } else if (userSource === UserSource.beeline) {
            ShopStore.buyValuteBeeline(bo.price).then((result: string) => {
                paymentNotificationService.setupPaymentCheckingTask();
            });
        } else if (userSource === UserSource.kong) {
            paymentNotificationService.setupPaymentCheckingTask();
            IntegrationUtils.showKongregatePaymentDialog(bo);
        } else if (userSource === UserSource.foto) {
            paymentNotificationService.setupPaymentCheckingTask();
            IntegrationUtils.showFotoPaymentDialog(bo);
        } else if (userSource === UserSource.crazygames) {
            ShopStore.buyValuteXsollaIFrame(bo.price).then((token: string) => {
                paymentNotificationService.setupPaymentCheckingTask();

                var options = {
                    access_token: token,
                    iframeOnly: true,
                    childWindow: {
                        target: '_self'
                    },
                    lightbox: {
                        modal: false
                    }
                };

                // @ts-ignore
                XPayStationWidget.init(options);
                // @ts-ignore
                XPayStationWidget.open();

            });
        } else if (externalUser) {
            ShopStore.buyValuteSocial(bo.price).then((url: string) => {
                paymentNotificationService.setupPaymentCheckingTask();
                window.location.href = url;
            });
        } else {
            let host = window.location.hostname;
            if (host.includes('lgtest.fun')) {
                ShopStore.buyValuteStub(bo.price).then(() => {
                    paymentNotificationService.setupPaymentCheckingTask();
                });
            } else {
                if (paymentChangeService.isUseXsolla()) {
                    ShopStore.buyValuteXsolla(bo.price).then((url: string) => {
                        paymentNotificationService.setupPaymentCheckingTask();
                        window.location.href = url;
                    });
                } else {
                    ShopStore.buyValuteRobokassa(bo.price, bo.title).then((url: string) => {
                        paymentNotificationService.setupPaymentCheckingTask();
                        window.location.href = url;
                    });
                }
            }
        }
    }
}
